export const CURRICULUM_ENDPOINTS = {
    OVERVIEW: "/v1/curriculum/overview",
} as const;
